import { curry } from "ramda";

export default window.SeatingSection = curry(function (middlewares, controller, url = null) {
  return function () {
    const fetchSection = (url) => {
      const proxy = R.curry(function (res, fn, data) {
        res.push(fn(data));
      });
      const callback = jQuery.Callbacks();
      const results = [];
      const callbackAccumulator = proxy(results);

      const handler = {
        map: function (fn) {
          callback.add(callbackAccumulator(fn));
          return handler;
        },
        mapAll: function (fns) {
          fns.forEach(handler.map);
          return handler;
        },
        forValues: function (fn) {
          callback.add(fn.bind(this, results));
        },
      };

      $.ajax({
        url,
        dataType: "json",
      }).then(function (response) {
        callback.fire(response);
      }).catch(function (response) {
        if (response.status && response.status === 422) {
          callback.fire(response.responseJSON);
        }
      });

      return handler;
    }

    const initialize = ({ url, middlewares, controller }) => {
      const seatingArrangementUrl = url || $("#arena").attr("data-seating-arrangement-url");
      fetchSection(seatingArrangementUrl)
        .mapAll(middlewares)
        .forValues(controller);
    };

    initialize({ url: url, middlewares, controller });
  };
});
